/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

export type SDSFormat = (typeof SDSFormat)[keyof typeof SDSFormat];

export const SDSFormat = {
    OSHA_HCS_2024: "OSHA_HCS_2024",
    EU_REACH_ANNEX_II_2020_878: "EU_REACH_ANNEX_II_2020_878",
    CANADA_WHMIS_HPR_2022: "CANADA_WHMIS_HPR_2022",
    AUSTRALIA_WHS_GHS_7: "AUSTRALIA_WHS_GHS_7",
    JAPAN_JIS_Z_7253_2025: "JAPAN_JIS_Z_7253_2025",
    GENERIC_GHS: "GENERIC_GHS",
    OSHA_HCS_2012: "OSHA_HCS_2012",
    EU_CLP: "EU_CLP",
    CANADA_WHMIS_2015: "CANADA_WHMIS_2015",
    AUSTRALIA_WHS: "AUSTRALIA_WHS",
    JAPAN_ISHA: "JAPAN_ISHA",
} as const;
